//For Top Menu
export interface IReportsDataServiceTopMenuModel {
    actionType: typeReportsDataServiceModelValues;
    value: typeReportsTopMenuItemsValues;
    selectedWindow: string;
}

export const ReportsDataServiceModelValues = {
    reportsTopMenuItems: "reportsTopMenuItems",
    reportsLeftMenuExpansion: "reportsLeftMenuExpansion",
} as const;
export type typeReportsDataServiceModelValues = typeof ReportsDataServiceModelValues[keyof typeof ReportsDataServiceModelValues];


export const ReportsTopMenuItemsValues = {
    print: "print",
    PDF: "PDF",
    XLS: "XLS",
    XLSX: "XLSX",
    Refresh: "Refresh",
    ReflowTable: 'ReflowTable'
} as const;
export type typeReportsTopMenuItemsValues = typeof ReportsTopMenuItemsValues[keyof typeof ReportsTopMenuItemsValues];

//For Left Menu Selection while refresh
export interface IReportsDataServiceLeftMenuExpantionModel {
    actionType: typeReportsDataServiceModelValues;
    value: string;//selected window
}
